$(document).ready(function() {
  $('button.boost-pfs-filter-custom-filter-button').trigger('click');
  $('.owl-carousel-feature-coll').owlCarousel({
    margin:10,
    nav:false,
    dots:false,
    lazyLoad:true,
    scrollbarType: 'scroll',
    loop:false,
    responsive:{
      0:{
        items:1,
        stagePadding: 60
      },
      600:{
        items:2
      },
      1000:{
        items:5
      }
    }
  });
  
  $('.custom-field__brands-slider .owl-carousel').owlCarousel({
    margin:10,
    nav:false,
    dots:false,
    lazyLoad:true,
    autoplay: true,
    scrollbarType: 'scroll',
    loop:true,
    responsive:{
      0:{
        items:2
      },
      600:{
        items:4
      },
      1000:{
        items:8
      }
    }
  });
  
  $('.owl-carousel-product').owlCarousel({
    margin:10,
    nav:false,
    dots:false,
    lazyLoad:true,
    scrollbarType: 'scroll',
    loop:true,
    items:1
  });
  
//   $('.site-nav--has-dropdownA.site-nav--is-megamenu').hover(function(e) {
//     e.preventDefault();
//     $('.sub-lower-dropdown').hide();
//   	$('.site-nav--has-dropdownA.site-nav--is-megamenu').removeClass('active-next-level');
//     $(this).toggleClass('active-next-level');
//   });

  $('body').click(function(evt){
    if(evt.target && evt.target.className && evt.target.className != '' && evt.target.className.includes("itstop") || evt.target.className.includes('site-nav__link') ||
      evt.target.className.includes('site-nav__dropdown-link') ||
      evt.target.className.includes('cart_discount_progress')) {
      return;
    }
    $('.sub-lower-dropdown').hide();
    $('.site-nav--has-dropdownA.site-nav--is-megamenu').removeClass('active-next-level');
  });
  
  
  $('a.site-nav__dropdown-link').hover(function() {
    setTimeout(() => {
        var atr = $(this).attr('data-menu');
        $('.sub-lower-dropdown').hide();
        $('.sub-lower-dropdown[data-menu='+atr+']').show();
  }, 50);
  });

  $('.boost-pfs-filter-tree-pf-v-sort-by').click(function() {
    $(this).attr('aria-expanded', 'true');
    $(this).parent().parent().toggleClass('boost-pfs-filter-option-collapsed');
    $(this).parent().parent().find('#boost-pfs-filter-tree-pf-v-sort-by').toggleClass('toggled');
  });
// boost-pfs-filter-option-collapsed

  $('.link-tab').click(function() {
    var t = $(this).attr('data-tab');
    $('.link-tab').removeClass('active');
    $('.section-fourteen-days').hide();
    $('.section-three-months').hide();
    $(this).addClass('active');
    if (t == 14) {
      $('.section-fourteen-days').show();
    } else {
      $('.section-three-months').show();
    }
    $('html,body').animate({
      scrollTop: $(".klarna-steps").offset().top - 100},
                           'slow');
  });

  $(".designer_filters a").click(function() {
    var a = $(this).attr('data-href');
    console.log(a, $("#"+a).offset().top);
    $('html, body').animate({
      scrollTop: $("#"+a).offset().top - 120
    }, 500);
  });


  $('.readmore').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'none';
  });
  $('.readless').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'block';
  });  

  var quotes = $(".quotes-ele");
  var quoteIndex = -1;

  function showNextQuote() {
    ++quoteIndex;
    quotes.eq(quoteIndex % quotes.length)
      .fadeIn(1000)
      .delay(1000)
      .fadeOut(1000, showNextQuote);
  }

  showNextQuote();
  
  var quotesm = $(".quotesm-ele");
  var quoteIndexm = -1;

  function showNextQuotem() {
    ++quoteIndexm;
    quotesm.eq(quoteIndexm % quotesm.length)
      .fadeIn(1000)
      .delay(1000)
      .fadeOut(1000, showNextQuotem);
  }

  showNextQuotem();
  
});
// $(window).on('load', function () {
//   $('button.boost-pfs-filter-custom-filter-button').trigger('click');
// });
